import SaudeCrianca from '../pages/SaudeCrianca/Index.vue';
import TestePezinho from '../pages/SaudeCrianca/TestePezinho/Index.vue';

export default [
    {
        path: '/saude-crianca',
        component: SaudeCrianca 
     },
     {
        path: '/teste-pezinho',
        component: TestePezinho 
     },
]